if (!customElements.get('countdown-bar')) {
  class CountdownBar extends HTMLElement {
    static observedAttributes = ["data-message", "data-upsell-timer"];

    constructor() {
      super();

      this.timerTickBind = this.timerTick.bind(this);
    }

    connectedCallback() {
      this.minutes = parseInt(this.dataset.minutes);
      this.message = this.dataset.message;
      this.upsellMessage = this.dataset.upsellMessage;
      this.timeDisplay = this.querySelector('[data-timer]');
      this.upsellTimeDisplay = this.querySelector('[data-upsell-timer]');
      this.start = new Date();
      this.endTime = new Date(this.start.setMinutes(this.start.getMinutes() + this.minutes));
      this.currentTimestamp = 0;

      window.requestAnimationFrame(this.timerTickBind);
    }

    disconnectedCallback() {
      console.log('CountdownBar disconnectedCallback');
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (newValue && (oldValue !== newValue)) {
        if (name === "data-message") {
          this.message = newValue;
        } else if (name === "data-message") {
          this.upsellMessage = newValue;
        }
      }
    }

    timerTick(timeStamp) {
      if (timeStamp - this.currentTimestamp >= 900) {
        this.currentTimestamp = timeStamp;
        const now = new Date();
        const timeRemaining = this.endTime.getTime() - now.getTime();
        let minutes = Math.floor(timeRemaining / 60000);
        let seconds = ((timeRemaining / 1000) % 60).toFixed(0).padStart(2, '0');

        if (seconds === '60') {
          minutes = minutes + 1;
          seconds = '00';
        }

        if (timeRemaining >= 0) {
          this.timeDisplay.innerHTML = this.message.replace('[time]', `${minutes}:${seconds}`);
          this.upsellTimeDisplay.innerHTML = this.upsellMessage.replace('[time]', `${minutes}:${seconds}`);
          window.requestAnimationFrame(this.timerTickBind);
        } else {
          this.timeDisplay.innerHTML = this.message.replace('[time]', `0:00`);
          this.upsellTimeDisplay.innerHTML = this.upsellMessage.replace('[time]', `0:00`);
          this.remove();
        }
      } else {
        window.requestAnimationFrame(this.timerTickBind);
      }
    }
  }

  customElements.define('countdown-bar', CountdownBar);
}